import Vue from 'vue'

// 价格千分位
Vue.filter('formatAmount', function (amount) {
  if (!amount) return 0
  const str = typeof amount === 'string' ? amount : amount.toString()
  const arr = str.split('')
  const l = arr.length - 1
  let result = ''
  for (let i = l; i > -1; i--) {
    if ((l - i + 1) % 3 === 1 && i !== l) {
      result = arr[i] + ',' + result
    } else {
      result = arr[i] + result
    }
  }
  return result
})
// 处理时间格式转换为印度时间 (IST, UTC+5:30)
Vue.filter('formattedDate', function (time) {
  const times = Number(time)
  const indiaTime = new Date(times + (5.5 * 60 * 60 * 1000))
  const day = String(indiaTime.getUTCDate()).padStart(2, '0')
  const month = String(indiaTime.getUTCMonth() + 1).padStart(2, '0')
  const year = String(indiaTime.getUTCFullYear())

  const formattedDate = `${day}-${month}-${year}` // 格式化后的日期
  return formattedDate
})

// 处理时间格式转换为印度时间:dd-MM-yyyy HH:mm:ss
Vue.filter('formattedDateTime', function (time) {
  const times = Number(time)
  const indiaTime = new Date(times + (5.5 * 60 * 60 * 1000))
  const day = String(indiaTime.getUTCDate()).padStart(2, '0')
  const month = String(indiaTime.getUTCMonth() + 1).padStart(2, '0')
  const year = String(indiaTime.getUTCFullYear())
  const hour = String(indiaTime.getUTCHours()).padStart(2, '0')
  const minute = String(indiaTime.getUTCMinutes()).padStart(2, '0')
  const second = String(indiaTime.getUTCSeconds()).padStart(2, '0')

  const formattedDateTime = `${day}-${month}-${year} ${hour}:${minute}:${second}` // 格式化后的日期时间
  return formattedDateTime
})
